export const USER_TYPES  = Object.freeze({
    BUSINESS_DEVELOPER : 'business-developer',
    SERVICE_PROVIDER : 'service-provider',
    EXPERT: 'expert',
    STARTUP: 'startup',
    TALENT: 'talent',
    INVESTOR: 'investor',
    ADMIN: 'admin'
  })